// import { ErrorsDisplay } from 'components/ErrorsDisplay'
import { A } from 'hookrouter'
import { useForm } from 'hooks/useForm'
import React, { FC, useState } from 'react'
import { Button, Col, Form, Row } from 'react-bootstrap'
import { resetPassword } from 'state/async_actions'
import { useAppContext } from 'state/context'
import { LOGIN_ROUTES } from '../LoginRouter'

type InputProps = { password: string; passwordConfirmation: string }
export const PasswordResetConfirmationForm: FC<{
  token: string
  initialResetValue?: boolean
}> = ({ token, initialResetValue = false }) => {
  const [, dispatch] = useAppContext()
  const [reset, setReset] = useState(initialResetValue)

  const [inputs, handleInputChange, handleSubmit, validated] = useForm<
    InputProps
  >(({ password, passwordConfirmation }) =>
    resetPassword(dispatch, password, passwordConfirmation, token, () =>
      setReset(true),
    ),
  )

  const passwordsMatch =
    inputs.password === undefined
      ? false
      : inputs.password === inputs.passwordConfirmation

  const resetMessage = (
    <>
      <h1>Your password has been reset.</h1>
      <A href={LOGIN_ROUTES.login}>Return to Login</A>
    </>
  )

  const form = (
    <>
      <Row>
        <Col>
          <h1>Reset your password</h1>
          {/* <ErrorsDisplay /> */}
        </Col>
      </Row>
      <Row>
        <Col>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Form.Group controlId="formBasicPassword">
              <Form.Label>Password</Form.Label>
              <Form.Control
                required
                onChange={handleInputChange}
                value={inputs.password || ''}
                name="password"
                type="password"
                placeholder="Enter Password"
                isValid={passwordsMatch}
              />
            </Form.Group>
            <Form.Group controlId="formBasicPasswordConfirmation">
              <Form.Label>Re-enter your Password</Form.Label>
              <Form.Control
                required
                onChange={handleInputChange}
                value={inputs.passwordConfirmation || ''}
                name="passwordConfirmation"
                type="password"
                placeholder="Enter Password Again"
                isValid={passwordsMatch}
              />
            </Form.Group>
            <Button variant="primary" value="Reset Password" type="submit">
              Reset Password
            </Button>
          </Form>
        </Col>
      </Row>
    </>
  )

  return reset ? resetMessage : form
}
